import React, { useEffect, useState } from 'react';
import {
	PieChart,
	Pie,
	Cell,
	Tooltip,
	Legend,
	BarChart,
	Bar,
	XAxis,
	YAxis,
	CartesianGrid,
	ResponsiveContainer,
	LineChart,
	Line,
	AreaChart,
	Area,
	LabelList,
} from 'recharts';
import moment from 'moment';
import { request } from '../../../services/utilities';
import TableLoading from '../../TableLoading';

import { Card, Col, Row, Statistic } from 'antd';
import SlidingPane from '../../SlidingPane';
import BedOccupancyHeatmap from '../../../pages/FrontDesk/Components/HeatMap';
import FrontDeskStaffAnalytics from '../../../pages/FrontDesk/modals/StaffAnalyticsModal';
import StaffLabOverview from '../../../pages/ClinicalLab/Modals/StaffOverviewModal';
import PaypointStaffAnalytics from '../../../pages/PayPoint/modals/PaypointStaffAnalytics';
import PharmacyStaffAnalytics from '../../../pages/Pharmacy/modal/PharmacyStaffOverview';
import StaffRadiologyOverview from '../../../pages/Radiology/modal/StaffRadiologymodal';
import StaffProcedureOverview from '../../../pages/Procedure/modals/StaffProcedureModal';
import NurseOverviewModal from '../../../pages/Nurse/Modals/NursesModal';
import DoctorOverviewModal from '../../../pages/Doctor/modals/DoctorsOverviewModal';
import HROverview from '../../../pages/HR/Modals/HROverviewModal';
import StaffStoreOverview from '../../../pages/Store/modals/StaffStoreModal';
import StaffCafeteriaOverview from '../../../pages/Cafeteria/modals/StaffCafteriaOvervieModal';
import StaffHmoDashboard from '../../../pages/Hmo/modals/StaffHMOModal';

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884d8', '#82ca9d', '#ffc0cb', '#faad14'];

const TimeRangeDropdown = ({ value, onChange, chartId }) => {
	return (
		<select
			value={value || 'past30Days'}
			onChange={e => onChange(e.target.value, chartId)}
			className="form-control form-control-sm rounded"
			style={{ width: '140px', marginBottom: '10px', borderRadius: '50px' }}
		>
			<option value="today">Today</option>
			<option value="pastWeek">Past Week</option>
			<option value="past30Days">Past 30 Days</option>
			<option value="lastMonth">Last Month</option>
			<option value="pastQuarter">Past Quarter</option>
			<option value="pastSixMonths">Past Six Months</option>
			<option value="pastYear">Past Year</option>
			<option value="lastYear">Last Year</option>
			<option value="pastThreeYears">Past Three Years</option>
			<option value="allTime">All Time</option>
		</select>
	);
};

const mapTimeRangeToApiFilter = range => {
	switch (range) {
		case 'today':
			return 'today';
		case 'pastWeek':
			return 'past-week';
		case 'lastMonth':
			return 'last-month';
		case 'pastQuarter':
			return 'past-quarter';
		case 'pastSixMonths':
			return 'past-six-months';
		case 'pastThreeYears':
			return 'past-three-years';
		case 'past30Days':
			return 'past-month';
		case 'pastYear':
			return 'past-year';
		case 'lastYear':
			return 'last-year';
		case 'allTime':
			return 'all-time';
		default:
			return 'past-month';
	}
};

const mapTimeRangeToApiFilterAlt = range => {
	switch (range) {
		case 'today':
			return 'Today';
		case 'pastWeek':
			return 'Past Week';
		case 'lastMonth':
			return 'Last Month';
		case 'pastQuarter':
			return 'Past Quarter';
		case 'pastSixMonths':
			return 'Past Six Months';
		case 'pastThreeYears':
			return 'Past Three Years';
		case 'past30Days':
			return 'Past 30 Days';
		case 'pastYear':
			return 'Past Year';
		case 'lastYear':
			return 'Last Year';
		case 'allTime':
			return 'All Time';
		default:
			return 'Past 30 Days';
	}
};

const StatsModal = ({
	module,
	selectedStaff,
	onClose,
	statsData,
	totalPatients,
	appointments: apps,
	departments,
	totalAdmissions,
	loaded,
}) => {
	return (
		<div
			style={{ position: 'absolute', overflowY: 'scroll', width: '100%', height: '98vh', zIndex: '1000', top: '0', left: '0' }}
			className=" modal-overlay"
		>
			<div
				style={{ padding: '50px', zIndex: '1000', top: '0', overflowY: 'scroll' }}
				//  className=" modal-content"
			>
				<div className=" w-100 d-flex justify-content-end align-items-center">
					<button className="modal-clos btn btn-danger" style={{ width: '50px' }} onClick={onClose}>
						&times;
					</button>
				</div>

				<div className=" bg-white p-5 m-5 d-flex   align-items-center mb-4" style={{ paddingLeft: '50px' }}>
					<div
						style={{ width: '100px', borderRadius: '50%', height: '100px', marginBottom: '20px' }}
						className="d-flex justify-content-center align-items-center flex-column mb-4 bg-info"
					>
						{/* <img src="" alt="logo" style={{ width: '100px', height: '100px', marginBottom: '20px' }} /> */}
					</div>

					<div className=" ml-4">
						<div>
							<label>First Name:</label>
							<span className="ml-2">{selectedStaff?.first_name || 'N/A'}</span>
						</div>
						<div>
							<label>Last Name:</label>
							<span className="ml-2">{selectedStaff?.last_name || 'N/A'}</span>
						</div>
						<div>
							<label>Email Address:</label>
							<span className="ml-2">{selectedStaff?.email || 'N/A'}</span>
						</div>
						<div>
							<label>Department:</label>
							<span className="ml-2">{selectedStaff?.department?.name || 'N/A'}</span>
						</div>
					</div>
				</div>

				{module === 'frontDesk' && <FrontDeskStaffAnalytics selectedStaff={selectedStaff} />}
				{module === 'labs' && <StaffLabOverview selectedStaff={selectedStaff} />}
				{module == 'paypoint' && <PaypointStaffAnalytics selectedStaff={selectedStaff} />}
				{module === 'pharmacy' && <PharmacyStaffAnalytics selectedStaff={selectedStaff} />}
				{module === 'radiology' && <StaffRadiologyOverview selectedStaff={selectedStaff} />}
				{module === 'procedure' && <StaffProcedureOverview selectedStaff={selectedStaff} />}
				{module === 'nurse' && <NurseOverviewModal selectedStaff={selectedStaff} />}

				{module === 'doctors' && <DoctorOverviewModal selectedStaf={selectedStaff} />}

				{module == 'hr' && <HROverview selectedStaff={selectedStaff} />}

				{module === 'store' && <StaffStoreOverview selectedStaff={selectedStaff} />}

				{module === 'cafeteria' && <StaffCafeteriaOverview selectedStaff={selectedStaff} />}

				{module === 'hmo' && <StaffHmoDashboard selectedStaff={selectedStaff} />}
			</div>
		</div>
	);
};

export default StatsModal;
